import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, TopMenuIcons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

type Props = IconProps;

export const ShippingLabelIcon = ({ id, onClick, size = 'small', className, disabled }: Props) => {
  return (
    <img
      id={id}
      src={TopMenuIcons.ShippingLabel}
      alt="img"
      className={cn(styles.icon, styles.button, className, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
